import React, { useCallback, memo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import forthComingIcon from "../../../../assets/NEST ICONS_Forthcoming.svg";
import achieversIcon from "../../../../assets/NEST ICONS_Achievers.svg";
import whatNewIcon from "../../../../assets/NEST ICONS_What's New.svg";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

const formatCount = (count) => {
  if (count === null || count === undefined || count === "") return "0";

  const hasRupeeSymbol = typeof count === "string" && count.startsWith("₹");
  const numericValue = hasRupeeSymbol
    ? parseFloat(count.replace(/[^0-9.-]/g, "")) || 0
    : Number(count) || 0;

  // Define a style object for consistent spacing
  const gapStyle = { margin: "0 0.1em" }; // Adjust '0.1em' for smaller/larger gaps

  if (numericValue >= 10000000) {
    return (
      <span style={{ display: "inline-flex", alignItems: "baseline" }}>
        {hasRupeeSymbol && <span style={gapStyle}>₹</span>}
        <span>{(numericValue / 10000000).toFixed(1)}</span>
        <span style={gapStyle}>Cr</span>
      </span>
    );
  }
  if (numericValue >= 100000) {
    return (
      <span style={{ display: "inline-flex", alignItems: "baseline" }}>
        {hasRupeeSymbol && <span style={gapStyle}>₹</span>}
        <span>{Math.floor(numericValue / 100000)}</span>
        <span style={gapStyle}>L</span>
      </span>
    );
  }
  if (numericValue >= 1000) {
    return (
      <span style={{ display: "inline-flex", alignItems: "baseline" }}>
        {hasRupeeSymbol && <span style={gapStyle}>₹</span>}
        <span>{Math.floor(numericValue / 1000)}</span>
        <span style={gapStyle}>K</span>
      </span>
    );
  }
  return (
    <span style={{ display: "inline-flex", alignItems: "baseline" }}>
      {hasRupeeSymbol && <span style={gapStyle}>₹</span>}
      <span>{Math.floor(numericValue)}</span>
    </span>
  );
};

const formatIndianCurrency = (value) => {
  if (value === undefined || value === null || value === "") return "";

  // Remove currency symbol if present and convert to number
  const num =
    typeof value === "string"
      ? parseFloat(value.replace(/[^0-9.]/g, ""))
      : Number(value);

  if (isNaN(num)) return value; // Return original if not a number

  // Format with Indian locale and remove decimal
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

const EventCard = memo(({ image, altText, title, onClick }) => (
  <div className="profile-event-carrd" onClick={onClick}>
    <div className="d-flex justify-content-center">
      <img className="img-event-profile" src={image} alt={altText} />
    </div>
    <h6 className="mt-1 d-flex justify-content-center">{title}</h6>
  </div>
));

const KPICardItem = memo(({ item, index, kpiInfo }) => {
  console.log("item, index, kpiInfo", item, index, kpiInfo);

  const navigate = useNavigate();
  const gradientClass = `gradient-bg-${(index % 6) + 1}`;
  const iconBgClass = `icon-bg-${(index % 6) + 1}`;

  const handleCardClick = useCallback(() => {
    if (item.link) {
      navigate(item.link, { state: item });
    }
  }, [item.link, navigate, item]);

  const renderWithTooltip = (content, value) => {
    const shouldHideTooltip =
      !value || value === 0 || value === "₹" || value === "₹0";

    return kpiInfo?.isFinance &&
      !shouldHideTooltip &&
      item?.text !== "My Referrals" ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-bottom" className="kpi-tooltip">
            {formatIndianCurrency(value)}
          </Tooltip>
        }
      >
        {content}
      </OverlayTrigger>
    ) : item?.text == "My Referrals" && item.count == 0 ? (
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id="tooltip-bottom" className="kpi-tooltip">
            {item.text == "My Referrals" && item.count == 0 && "Refer Now"}
          </Tooltip>
        }
      >
        {content}
      </OverlayTrigger>
    ) : (
      content
    );
  };

  // Case 1: Director view with Actual/Projected
  if (
    kpiInfo?.isDirector &&
    item.title1 === "Actual" &&
    item.title2 === "Proj."
  ) {
    const directorLevelKPI = (value) => {
      if (value === null || value === undefined) return false;
      const strValue = String(value).trim();
      return !["₹0", "₹", "0", ""].includes(strValue);
    };
    return (
      <div
        className={`interview-card ${gradientClass}`}
        onClick={handleCardClick}
      >
        <div className="finance-interview-card-section">
          <div className={`interview-icon ${iconBgClass}`}>
            <img src={item.img} alt="icon" />
          </div>
          <div className="finance-interview-number">{item.text || ""}</div>
        </div>
        <div className="finance-interview mt-1">
          <div className="d-flex flex-direction-col justify-content-between">
            <div className="finance-text text-black">{item.title1 || ""}</div>
            {directorLevelKPI(item.count) ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    id="tooltip-count"
                    className="director-custom-tooltip"
                  >
                    {formatIndianCurrency(item.count)}
                  </Tooltip>
                }
              >
                <div className="finance-Count text-black">
                  {formatCount(item.count || "")}
                </div>
              </OverlayTrigger>
            ) : (
              <div className="finance-Count text-black">
                {formatCount(item.count || "")}
              </div>
            )}
          </div>
        </div>
        <div className="finance-interview mt-1">
          <div className="d-flex flex-direction-col justify-content-between">
            <div className="finance-text text-black">{item.title2 || ""}</div>
            {directorLevelKPI(item.projected) ? (
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip
                    id="tooltip-count"
                    className="director-custom-tooltip"
                  >
                    {formatIndianCurrency(item.projected)}
                  </Tooltip>
                }
              >
                <div className="finance-Count text-black">
                  {formatCount(item.projected || "")}
                </div>
              </OverlayTrigger>
            ) : (
              <div className="finance-Count text-black">
                {formatCount(item.projected || "")}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Case 2: Finance view with projected data
  if (kpiInfo?.isFinance && item.hasOwnProperty("projected")) {
    return (
      <div
        className={`interview-card ${gradientClass}`}
        onClick={handleCardClick}
      >
        <div className="finance-interview-card-section">
          <div className={`interview-icon ${iconBgClass}`}>
            <img src={item.img} alt="icon" />
          </div>
          <div className="finance-interview-number">{item.text || ""}</div>
        </div>
        <div className="finance-interview mt-1">
          <div className="d-flex flex-direction-col justify-content-between">
            <div className="finance-text text-black">{item.title1 || ""}</div>
            {renderWithTooltip(
              <div className="finance-Count text-black">
                {formatCount(item.count || "")}
              </div>,
              item.count
            )}
          </div>
        </div>
        <div className="finance-interview mt-1">
          <div className="d-flex flex-direction-col justify-content-between">
            <div className="finance-text text-black">{item.title2 || ""}</div>
            {renderWithTooltip(
              <div className="finance-Count text-black">
                {formatCount(item.projected || "")}
              </div>,
              item.projected
            )}
          </div>
        </div>
      </div>
    );
  }

  // Case 3: Card with projected data (two columns)
  if (item.hasOwnProperty("projected") && item.title1 && item.title2) {
    return (
      <div
        className={`interview-card ${gradientClass}`}
        onClick={handleCardClick}
      >
        <div className="interview-card-section mb-1">
          <div className={`interview-icon ${iconBgClass}`}>
            <img src={item.img} alt="icon" />
          </div>
        </div>
        <div
          className="d-flex justify-content-between gap-2"
          style={{ marginBottom: "2px" }}
        >
          <div>
            <div className="d-flex flex-direction-col justify-content-between">
              <div
                className="finance-text-nr"
                style={{ marginRight: "4px", fontWeight: "bold" }}
              >
                {item.title1 || ""}
              </div>
              {renderWithTooltip(
                <div className="finance-Count">
                  {formatCount(item.count || "")}
                </div>,
                item.count
              )}
            </div>
          </div>
          <div className="d-flex flex-direction-col justify-content-between">
            <div
              className="finance-text-nr"
              style={{ marginRight: "4px", fontWeight: "bold" }}
            >
              {item.title2 || ""}
            </div>
            {renderWithTooltip(
              <div className="finance-Count">
                {formatCount(item.projected || "")}
              </div>,
              item.projected
            )}
          </div>
        </div>
        <div className="interview-text">{item.text || ""}</div>
      </div>
    );
  }

  // Case 4: Default simple card (count + text)
  return (
    <div
      className={`interview-card ${gradientClass}`}
      onClick={handleCardClick}
    >
      <div className="interview-card-section">
        <div className={`interview-icon ${iconBgClass}`}>
          <img src={item.img} alt="icon" />
        </div>
        {renderWithTooltip(
          <div className="interview-number">
            {formatCount(item.count || "")}
          </div>,
          item.count
        )}
        <div className="interview-text">{item.text || ""}</div>
      </div>
    </div>
  );
});

const KPICard = ({
  KPI,
  kpiInfo,
  visibleCards,
  mainColClass,
  sideColClass,
  isSidebarOpen,
}) => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselItems = [
    {
      title: "Forthcoming",
      onClick: () => navigate("/forthcoming"),
      icon: forthComingIcon,
      type: "forthcoming",
    },
    {
      title: "What's New?",
      onClick: () => navigate("/whatsnew"),
      icon: whatNewIcon,
      type: "whatsNew",
    },
    {
      title: "Achievers",
      onClick: () => navigate("/achievers"),
      icon: achieversIcon,
      type: "achievers",
    },
  ];

  useEffect(() => {
    if (isSidebarOpen && carouselItems.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [isSidebarOpen, carouselItems.length]);

  const renderCarouselItem = (item, index, isCarousel = false) => (
    <div
      key={index}
      className="forthcomingKpi-card"
      style={
        isCarousel
          ? {
              minWidth: "100%",
              height: "100%",
              flexShrink: 0,
              marginRight: "1px",
            }
          : {}
      }
      onClick={item.onClick}
    >
      <div className="forthcomingKpi-icon-circle">
        <img src={item.icon} alt={item.title} />
      </div>
      <h2 className="forthcomingKpi-title">{item.title}</h2>
    </div>
  );

  return (
    <div className="row">
      <div className={`${mainColClass} dashKPI`}>
        <div className="container-fluid p-0">
          <div className="cards-wrapper p-0" style={{ cursor: "pointer" }}>
            {KPI?.slice(0, visibleCards).map((item, index) => (
              <KPICardItem
                key={`kpi-${index}`}
                item={item}
                index={index}
                kpiInfo={kpiInfo}
              />
            ))}
          </div>
        </div>
      </div>
      <div className={`${sideColClass} quick-action dashKPI`}>
        <div className="quick-profile-section">
          {isSidebarOpen ? (
            <div
              className="carousel-container"
              style={{
                position: "relative",
                height: "80px",
                overflow: "hidden",
              }}
            >
              <div
                className="carousel-track"
                style={{
                  display: "flex",
                  height: "100%",
                  transform: `translateX(-${currentSlide * 100}%)`,
                  transition: "transform 0.5s ease-in-out",
                }}
              >
                {carouselItems.map((item, index) =>
                  renderCarouselItem(item, index, true)
                )}
              </div>
            </div>
          ) : (
            <div className="forthcomingKpi-container">
              {carouselItems.map((item, index) =>
                renderCarouselItem(item, index)
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(KPICard);
